<template>
  <div>
    <div>
      <div class="title1">添加个人银行卡</div>
      <div class="title2">请添加本人持有的银行卡</div>
    </div>
    <div>
      <div class="lineBox flex borderT">
        <div class="title">身份证号</div>
        <div class="flex1">
          <input
            class="lineInput"
            disabled="disabled"
            v-model="params.idNumber"
            placeholder="请输入身份证号"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">姓名</div>
        <div class="flex1">
          <input
            class="lineInput"
            disabled="disabled"
            v-model="params.name"
            placeholder="请输入姓名"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">银行卡号</div>
        <div class="flex1">
          <input
            class="lineInput"
            v-model="params.accountNumber"
            type="text"
            @blur="getBankName"
            placeholder="请输入银行卡号"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">开户银行</div>
        <div class="flex1">
          <input
            class="lineInput"
            disabled="disabled"
            v-model="params.bankName"
            placeholder=""
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">预留手机号</div>
        <div class="flex1">
          <input
            class="lineInput"
            v-model="params.phone"
            placeholder="请输入预留手机号"
          />
        </div>
      </div>
      <div class="inputWapper protocol">
        <CheckImgbox v-model="checked" class="checkbox-style" />

        <div class="protocol-text">
          请阅读并同意<a
            class="protocol-link"
            href="/policy/service_policy.html"
            @click="watchServe"
            >《电商业务服务协议》</a
          >
        </div>
      </div>
    </div>
    <div class="addButton" @click="addBankCard">添加</div>
  </div>
</template>

<script>
import { creatBankCard, approveInfo } from "../../api/bank.js";
import CheckImgbox from "@/components/CheckImgbox";
// import { isInWechatMP } from '@/utils/wx-utils'
export default {
  components: { CheckImgbox },
  data() {
    return {
      wait_timer: false,
      isDisable: false,
      params: {
        idNumber: "",
        accountNumber: "",
        bankName: "",
        name: "",
        requestNo: new Date().getTime(),
        phone: ""
      },
      checked: false
    };
  },
  created() {
    this.approveInfo();
  },
  mounted() {
    let BIN = require("bankcardinfo");
    let that = this;
    let res = this.$ls.get("accountNumber");
    if (res && res.data) {
      that.params.accountNumber = res.data;
      BIN.getBankBin(that.params.accountNumber, function(err, data) {
        if (!err) {
          that.params.bankName = data.bankName;
        } else {
          that.params.bankName = "";
        }
      });
    }
  },
  methods: {
    watchServe() {
      this.$ls.set("accountNumber", this.params.accountNumber);
      location.href = "/policy/service_policy.html";
    },
    approveInfo() {
      approveInfo().then(res => {
        this.params.name = res.realName;
        this.params.idNumber = res.idCardNumber;
        this.params.phone = res.phone;
      });
    },
    checkboxChange(e) {
      this.checked = e.detail.value.length > 0;
    },
    getBankName() {
      let BIN = require("bankcardinfo");
      this.$ls.set("accountNumber", this.params.accountNumber);
      let that = this;
      BIN.getBankBin(this.params.accountNumber, function(err, data) {
        if (!err) {
          that.params.bankName = data.bankName;
        } else {
          that.params.bankName = "";
        }
      });
    },
    addBankCard() {
      if (this.checked == false) {
        this.$showError("请先阅读并同意相关协议");
      } else {
        this.$vux.loading.show();
        creatBankCard(this.params)
          .then(() => {
            this.$ls.remove("accountNumber");
            this.$vux.loading.hide();
            this.$router.push({ path: "/bankCard/bankCard" });
          })
          .catch(err => {
            this.$ls.remove("accountNumber");
            this.$vux.loading.hide();
            this.$showMessage(err);
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.checkbox-style {
  width: 32px;
  height: 32px;
  margin-right: 20px;
  display: inline-block;
}
.protocol-text {
  display: inline;
}
.inputWapper {
  align-items: center;
  margin: 30px 60px 0 60px;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 12px;
  overflow: hidden;
  &.protocol {
    border: none;
    font-size: 12px;
    color: #bfbfbf;
    display: flex;
    .protocol-link {
      font-size: 11px;
      color: #007bec;
    }
  }
}
.title1 {
  text-align: center;
  font-size: 20px;
  line-height: 40px;
  padding: 90px 0 40px 0;
  font-weight: bold;
}
.title2 {
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  padding-bottom: 90px;
}
.borderT {
  border-top: 1px solid #e8e8e8;
}
.lineBox {
  margin: 0 50px;
  height: 50px;
  line-height: 50px;
  padding: 24px 16px;
  border-bottom: 1px solid #e8e8e8;
}
.title {
  font-size: 15px;
}
.lineInput {
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #474747;
  font-size: 14px;
}
.codeButton {
  width: 160px;
  height: 50px;
  line-height: 50px;
  text-align: right;
  font-size: 14px;
  border-left: 1px solid #e8e8e8;
  color: #1573ff;
  margin-left: 20px;
}
.addButton {
  margin: 100px 50px 0;
  text-align: center;
  font-size: 16px;
  height: 88px;
  line-height: 88px;
  background: #007bec;
  color: #fff;
  border-radius: 10px;
}
input {
  width: 100%;
  border: none;
  background: none;
  text-align: right;
}
</style>
